import BossModel from "@/models/BossModel";
import Customer from "@/models/Customer/Customer";
import PublicImage from "@/models/PublicImage/PublicImage.js";

export default class Company extends BossModel {

    static apiUrl = 'company';

    static entity = 'companies';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null).nullable(),
            kvk_number: this.string(null).nullable(),
            vat_number: this.string(null).nullable(),
            is_travel_agency: this.boolean(0).nullable(),
            logo_public_image_id: this.number(null).nullable(),
            customers: this.hasMany(Customer, 'company_id'),
            logoPublicImage: this.belongsTo(PublicImage, 'logo_public_image_id'),
        }
    }
}
